import * as React from 'react';
import Product from "@system/config/product";

const ContinueShopping = (props) => {
    return (
        <>
            <button type="button" className="bs5 btn btn-primary w-100 mt-2 d-block "
                onClick={() => {
                    window.location.href = Product.getProductListingPageRouteURL()
                }}>CONTINUE SHOPPING</button>
        </>
    );
}

export default ContinueShopping;